import { render, staticRenderFns } from "./JobGrades.vue?vue&type=template&id=1bb130a8&"
import script from "./JobGrades.vue?vue&type=script&lang=js&"
export * from "./JobGrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports